<ng-container *ngIf="show">
  <mat-progress-bar
    [mode]="mode"
    [value]="progress"></mat-progress-bar>
</ng-container>
